<template>
  <el-form-item
    v-if="$attrs['label-postion'] == 'left'"
    :label-width="$attrs['label-width']"
    :prop="$attrs['prop']"
    :label="$attrs['label']"
  >
    <el-checkbox
      v-model.trim="innerValue"
      :disabled="$attrs['disabled']"
      @change="onChange"
    ></el-checkbox>
  </el-form-item>
  <el-form-item
    v-else
    :label-width="$attrs['label-width']"
    :prop="$attrs['prop']"
  >
    <el-checkbox
      v-model.trim="innerValue"
      :label="$attrs['label']"
      :disabled="$attrs['disabled']"
      @change="onChange"
    ></el-checkbox>
  </el-form-item>
</template>
<script>
  import mixins from '@/utils/mixForm'
  export default {
    name: 'VabCheckbox',
    mixins: [mixins],
    created: function () {
      if (!this.$attrs.type) {
        this.type = 'boolean'
      }
    },
    methods: {
      onChange(value) {
        let val = value
        if (this.codeEnum) {
          if (value) {
            val = this.codeEnum.enum_1.value
          } else {
            if (this.$baseLodash.has(this.codeEnum, 'enum_0')) {
              val = this.codeEnum.enum_0.value
            } else {
              val = this.codeEnum.enum_blank.value
            }
          }
        }
        this.handleChange(val)
      },
      setValue(val) {
        val = this.checkEnumFlag(val)
        this.innerValue = val
      },
    },
  }
</script>
